import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RoundPipe } from './round.pipe';

@NgModule({
  declarations: [RoundPipe],
  imports: [CommonModule],
  exports: [RoundPipe]
})
export class RoundModule {}
